/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
G.MuteReason = {
    UserChoice: 'userChoice',
    AppPaused: 'appPaused',
};

G.createSoundManager = function createSoundManager(getAudioMutedFunc, _setAudioMutedFunc) {
    const fxMuted = new G.Reasons((_mute) => {
        updateAudioMuted();
    });
    const musicMuted = new G.Reasons((_mute) => {
        updateMusicMuted();
        updateAudioMuted();
    });
    let pauseLocked = false;

    G.phaserStageVisibilityChanged.add((paused) => {
        document.hidden || paused ? pause() : resume();
    });

    setInterval(() => {
        const saveData = G.saveState.data;
        if (saveData) {
            G.soundManager.setMusicEnabled(G.MuteReason.UserChoice, !saveData.mute);
            G.soundManager.setSoundEnabled(G.MuteReason.UserChoice, !saveData.muteFx);
        }

        updateMusicMuted();
    }, 1000);

    return {
        pause,
        resume,
        getSoundEnabled,
        setSoundEnabled,
        getMusicEnabled,
        setMusicEnabled,
        wrapAudioElement,
    };

    function pause(lock = false) {
        if (pauseLocked) return;
        pauseLocked = lock;
        setSoundEnabled(G.MuteReason.AppPaused, false);
        setMusicEnabled(G.MuteReason.AppPaused, false);
    }

    function resume(unlock = false) {
        if (pauseLocked && !unlock) return;
        pauseLocked = false;
        setSoundEnabled(G.MuteReason.AppPaused, true);
        setMusicEnabled(G.MuteReason.AppPaused, true);
    }

    function getSoundEnabled() {
        return !fxMuted.hasAny();
    }
    function setSoundEnabled(reason, enabled) {
        fxMuted.setPresence(reason, !enabled);
    }

    function getMusicEnabled() {
        return !musicMuted.hasAny();
    }
    function setMusicEnabled(reason, enabled) {
        musicMuted.setPresence(reason, !enabled);
    }

    function updateMusicMuted() {
        if (!G.music) {
            console.warn('G.music is not available');
            return;
        }

        if (window.pausedByAd || document.hidden) {
            G.music.pause();
        } else {
            musicMuted.hasAny() ? G.music.pause() : G.music.resume();
        }
    }

    function updateAudioMuted() {
        const { muteFx } = getAudioMutedFunc();
        const newMuted = !getSoundEnabled();
        if (muteFx !== newMuted) {
            setAllSfxMuted(newMuted);
        }
    }

    function setAllSfxMuted(muted = true) {
        if (G.sfx) return;

        for (const [key, sfx] of Object.entries(G.sfx)) {
            if (!sfx || key === 'music') continue;

            if (muted) sfx.pause();
            else sfx.resume();
        }
    }

    function wrapAudioElement(audio, soundKey, audiosprite) {
        const wrappedAudio = Object.create(audio);
        if (soundKey === 'music') {
            audio.loop = true;
        }
        wrappedAudio.play = wrappedPlay;
        return wrappedAudio;

        function wrappedPlay(volume = 1) {
            if (soundKey === 'music') {
                audio.play(); // Need to instaniate...
                if (!getMusicEnabled()) {
                    audio.pause();
                }
            } else if (getSoundEnabled()) {
                // Not music. Must be sfx
                if (soundKey === 'coin_collect' || soundKey === 'pop' || soundKey === 'boom') {
                    audiosprite.get(soundKey).allowMultiple = true;
                    audiosprite.get(soundKey).volume = 0.7;
                }
                audiosprite.play(soundKey, volume);
            }
        }
    }
};
